import { ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const knowledgeHubArticleEmbedEditorRoute: InvariantRoute = {
	name: ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR,
	path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
	query: ['draftShareId?', 'topicId?'],
};
